import useAnalyzeDocumentToAI from '@/hooks/library/useAnalyzeDocumentToAI';
import { useScreen } from '@/hooks/useScreen';
import useToggle from '@/hooks/useToggle';
import { IResponseDetailMaterial } from '@/interfaces/doccen-lib/contentManagement.interface';
import { ILastestSubscriptionPlanResponse } from '@/interfaces/subscription.interface';
import dynamic from 'next/dynamic';
import DocumentDetailProvider from 'state/document/DocumentDetailProvider';

const DynamicDocumentDetailBottomSheet = dynamic(
  () =>
    import(
      '@/components/elements/doccen-lib/document-detail/DocumentDetailBottomSheet'
    )
);
const DynamicDocumentDetailSidebar = dynamic(
  () =>
    import(
      '@/components/elements/doccen-lib/document-detail/DocumentDetailSidebar'
    )
);
const DynamicModalDocumentDetailUpgradePlan = dynamic(
  () =>
    import(
      '@/components/elements/doccen-lib/document-detail/ModalDocumentDetailUpgradePlan'
    )
);
const DynamicSubscriptionModal = dynamic(
  () => import('@/components/elements/subscription/SubscriptionModal')
);

const DocumentDetailMoreInformation = ({
  document,
  latestSubscription,
}: {
  document: IResponseDetailMaterial | undefined;
  latestSubscription: ILastestSubscriptionPlanResponse | undefined;
}) => {
  const { isDesktop } = useScreen();

  const [openModalUpgradePlan, toggleModalUpgradePlan] = useToggle();
  const [openSubscriptionModal, setOpenSubscriptionModal] = useToggle();

  const mutationResult = useAnalyzeDocumentToAI(
    document,
    toggleModalUpgradePlan,
    setOpenSubscriptionModal
  );

  return (
    <>
      <DocumentDetailProvider
        document={document}
        mutationResult={mutationResult}
        toggleModalUpgradePlan={toggleModalUpgradePlan}
        latestSubscription={latestSubscription}
      >
        {!isDesktop ? (
          <DynamicDocumentDetailBottomSheet />
        ) : (
          <DynamicDocumentDetailSidebar />
        )}
      </DocumentDetailProvider>

      {openModalUpgradePlan && (
        <DynamicModalDocumentDetailUpgradePlan
          open={openModalUpgradePlan}
          onClose={toggleModalUpgradePlan}
        />
      )}

      {openSubscriptionModal && (
        <DynamicSubscriptionModal
          open={openSubscriptionModal}
          toggle={setOpenSubscriptionModal}
        />
      )}
    </>
  );
};

export default DocumentDetailMoreInformation;
